var map = {
	"./0iconmonstr-paintbrush-7.svg": 3227,
	"./1bluch.png": 628,
	"./2redch.png": 5653,
	"./3grech.png": 3660,
	"./4golch.png": 80,
	"./5grach.png": 8620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9894;